import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LxlibUtilModule } from '@lxlib/util';
import { ACLIfDirective } from './acl-if.directive';
import { ACLDirective } from './acl.directive';
import { ACLService } from './acl.service';

const COMPONENTS = [ACLDirective, ACLIfDirective];

@NgModule({
  imports: [CommonModule, LxlibUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class LxlibACLModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LxlibACLModule,
      providers: [ACLService],
    };
  }
}
